import { useEffect, useState } from "react";

const STORAGE_KEY = "theme";

function storedTheme() {
  try {
    return localStorage.getItem(STORAGE_KEY) || "light";
  } catch {
    return "light";
  }
}

/**
 * Aplica o tema guardado no arranque da aplicação. Sem isto, o tema só era
 * aplicado quando um ThemeToggle estava montado — e no painel o botão vive
 * dentro do menu de conta, que só existe enquanto está aberto.
 */
export function applyStoredTheme() {
  if (typeof document !== "undefined") document.documentElement.setAttribute("data-theme", storedTheme());
}

export function useTheme() {
  const [theme, setTheme] = useState(storedTheme);
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      /* ignore: armazenamento bloqueado */
    }
  }, [theme]);
  return [theme, setTheme];
}
